import { packBit } from "@/services/Utility";

export const getSubdivisonColumnDefault = (): number => {
  let columns = 0;
  columns = packBit(columns, true, SubdivisionColumns.projectName.bit);
  columns = packBit(columns, true, SubdivisionColumns.projectCode.bit);
  columns = packBit(columns, true, SubdivisionColumns.drawNumber.bit);
  columns = packBit(columns, true, SubdivisionColumns.propertyType.bit);
  columns = packBit(columns, true, SubdivisionColumns.dateCreated.bit);
  columns = packBit(columns, true, SubdivisionColumns.completionPosted.bit);
  columns = packBit(columns, true, SubdivisionColumns.extensions.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalCreditCommitment.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalEquity.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalAdjustedBudget.bit);
  columns = packBit(columns, true, SubdivisionColumns.retailValue.bit);
  columns = packBit(columns, true, SubdivisionColumns.salesPrice.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalThisDraw.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalDrawnToDate.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalFundsAvailable.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalBudgetDrawn.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalSiteComplete.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalHardCosts.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalSoftCosts.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalLand.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalInterest.bit);
  columns = packBit(columns, true, SubdivisionColumns.totalInspection.bit);
  columns = packBit(columns, true, SubdivisionColumns.releaseDate.bit);
  columns = packBit(columns, true, SubdivisionColumns.releaseAmount.bit);

  return columns;
};

export const SubdivisionColumns = {
  projectName: { bit: 0, alwaysVisible: true, label: "Project Name" },
  projectCode: { bit: 1, alwaysVisible: true, label: "Loan #" },
  drawNumber: { bit: 2, alwaysVisible: false, label: "Draw Number" },
  propertyType: { bit: 3, alwaysVisible: false, label: "Property Type" },
  dateCreated: { bit: 4, alwaysVisible: false, label: "Start Date" },
  completionPosted: { bit: 5, alwaysVisible: false, label: "Completion Posted" },
  extensions: { bit: 6, alwaysVisible: false, label: "Extensions" },
  totalCreditCommitment: { bit: 7, alwaysVisible: false, label: "Credit Commitment" },
  totalEquity: { bit: 8, alwaysVisible: false, label: "Equity Balance" },
  totalAdjustedBudget: { bit: 9, alwaysVisible: false, label: "Total Cost" },
  retailValue: { bit: 10, alwaysVisible: false, label: "Retail Value" },
  salesPrice: { bit: 11, alwaysVisible: false, label: "Sales Price" },
  totalBudgetDrawn: { bit: 12, alwaysVisible: false, label: "% Drawn" },
  totalSiteComplete: { bit: 13, alwaysVisible: false, label: "% Inspected" },
  releaseAmount: { bit: 14, alwaysVisible: false, label: "Release Amount" },
  releaseDate: { bit: 15, alwaysVisible: false, label: "Release Date" },
  totalHardCosts: { bit: 16, alwaysVisible: false, label: "Hard Cost" },
  totalSoftCosts: { bit: 17, alwaysVisible: false, label: "Soft Cost" },
  totalLand: { bit: 18, alwaysVisible: false, label: "Land" },
  totalInterest: { bit: 19, alwaysVisible: false, label: "Interest" },
  totalInspection: { bit: 20, alwaysVisible: false, label: "Inspection" },
  initialBudget: { bit: 21, alwaysVisible: false, label: "Initial Budget" },
  budgetAmount: { bit: 22, alwaysVisible: false, label: "Budget Amount" },
  cumulativeAdjustment: { bit: 23, alwaysVisible: false, label: "Cumulative Adjustment" },
  priorDrawnToDate: { bit: 24, alwaysVisible: false, label: "Prior Drawn To Date" },
  totalThisLoan: { bit: 25, alwaysVisible: false, label: "This Draw Loan" },
  totalThisEquity: { bit: 26, alwaysVisible: false, label: "This Draw Equity" },
  netThisDraw: { bit: 27, alwaysVisible: false, label: "Net This Draw Loan" },
  priorEquityToDate: { bit: 28, alwaysVisible: false, label: "Prior Equity To Date" },
  projectedOver: { bit: 29, alwaysVisible: false, label: "Projected Over / (Under)" },
  loanToDate: { bit: 30, alwaysVisible: false, label: "Loan Drawn To Date" },
  netThisDrawEquity: { bit: 31, alwaysVisible: false, label: "Net This Draw Equity" },
  equityToDate: { bit: 32, alwaysVisible: false, label: "Equity Drawn To Date" },
  totalDrawnToDate: { bit: 33, alwaysVisible: false, label: "Total Drawn To Date" },
  variance: { bit: 34, alwaysVisible: false, label: "Variance" },
  totalFundsAvailable: { bit: 35, alwaysVisible: false, label: "Funds Available" },
  totalFundsRequired: { bit: 36, alwaysVisible: false, label: "Funds Required" },
  totalRetainagePriorDraw: { bit: 37, alwaysVisible: false, label: "Total Retainage Prior Draws" },
  totalReleasedPriorDraw: { bit: 38, alwaysVisible: false, label: "Total Released Prior Draws" },
  totalRetainage: { bit: 39, alwaysVisible: false, label: "Total Retainage" },
  totalReleased: { bit: 40, alwaysVisible: false, label: "Total Released" },
  retainageBalance: { bit: 41, alwaysVisible: false, label: "Retainage Balance" },
  totalThisDraw: { bit: 42, alwaysVisible: false, label: "This Draw" },
};
